import {reisy} from 'reisy';

export const styles = reisy`

/******************** Typography ********************/
@namespace Typography;
Header {
	font-family: $Fonts.title;
	color: $Colors.TextLight;
	overflow-wrap: break-word;
	word-wrap: break-word;
}
HeaderHeading {
	font: normal 3.5em $Fonts.title;
	line-height: 1em;
	color: $Colors.TextLight;
}
HeaderSlogan {
	font: normal normal 1.4em $Fonts.subtitle;
	color: inherit;
}
ArticleTitle {
	@extends Helpers.Hyphens;
	font-family: $Fonts.title;
	font-size: 1.3em;
	font-weight: normal;
	color: $Colors.TextDark;
}
ArticleSubtitle {
	@extends Helpers.Hyphens;
	font-family: $Fonts.subtitle;
	font-size: 1.1em;
	font-weight: normal;
	color: $Colors.TextDark;
}
ArticleDesc {
	@extends Helpers.Hyphens;
	font-family: $Fonts.text;
	color: $Colors.TextDark;
}
SlideTitle {
	@extends Helpers.Hyphens;
	margin: 0;
	font-family: $Fonts.title;
	font-weight: normal;
	color: $Colors.TextLight;
}
SlideSubtitle {
	@extends Helpers.Hyphens;
	margin: 0;
	font-family: $Fonts.subtitle;
	font-weight: normal;
}
SlideDesc {
	@extends Helpers.Hyphens;
	font-family: $Fonts.text;
}
SectionTitle {
	@extends Helpers.Hyphens;
	font-family: $Fonts.title;
	font-size: 2.5em;
	font-weight: normal;
	color: $Colors.TextDark;
}
SectionSubtitle {
	@extends Helpers.Hyphens;
	font-family: $Fonts.subtitle;
	font-size: 1.6em;
	font-weight: normal;
	color: $Colors.TextDark;
}
SectionDesc {}
Footer {
	font-family: $Fonts.text;
	color: $Footer.ForegroundColor;
}
FooterHeading {
	font-family: $Fonts.title;
	font-size: 1.5em;
	color: $Footer.ForegroundColor;
}
FooterCopyright {
	font-family: $Fonts.aside;
	color: $Footer.ForegroundSecondaryColor;
}`;



// WEBPACK FOOTER //
// ./lib/styling/typography.js